/** Env-invariant, so deliberately not in environment.*.ts. */

/** Largest file the dialog accepts. Mirrors MAX_DOC_BYTES in src/utils/upload-limits.ts. */
export const MAX_UPLOAD_BYTES = 32 * 1024 * 1024;

export const formatBytes = (bytes: number): string =>
  `${(bytes / (1024 * 1024)).toFixed(1)} MiB`;

/** How many documents may upload at once. Large files make unbounded parallelism costly. */
export const MAX_CONCURRENT_UPLOADS = 20;
